module.exports = __webpack_public_path__ + "img/antenna-03.84ed0e83.svg";